export function parseHashState() {
  try {
    const params = new URLSearchParams(window.location.hash.slice(1));
    const n = (k) => { const v = parseFloat(params.get(k)); return isFinite(v) && v > 0 ? v : null; };
    const i = (k) => { const v = parseInt(params.get(k));   return isFinite(v) && v > 0 ? v : null; };
    return {
      lx: n('lx'), ly: n('ly'), lz: n('lz'),
      f: i('f'), rt60: n('rt60'),
      theme: ['dark','light'].includes(params.get('theme')) ? params.get('theme') : null,
      units: ['metric','imperial'].includes(params.get('units')) ? params.get('units') : null,
      mode: params.get('mode') || null,
    };
  } catch { return {}; }
}

export const INITIAL_HASH = parseHashState();
